import moment from 'moment'
import Validators from '@/utils/validators'

export default {
    beforeMount() {
        this.validators = Validators
    },
    methods: {
        validateDateFormat(value, format) {
            if ((format === '' || format === null)) return false
            if (value && format) {
                const checked = moment(value, format, true).isValid()
                return checked || !checked
            }

            return true
        },
        toJavaCompatibleDuration(value, unit) {
            // Convierte años y meses a días
            const duration = moment.duration(value, unit)
            const totalDays = Math.floor(duration.asDays())
            const hours = duration.hours()
            const minutes = duration.minutes()
            const seconds = duration.seconds()

            let iso = 'P'
            if (totalDays > 0) iso += `${totalDays}D`
            if (hours > 0 || minutes > 0 || seconds > 0) {
                iso += 'T'
                if (hours > 0) iso += `${hours}H`
                if (minutes > 0) iso += `${minutes}M`
                if (seconds > 0) iso += `${seconds}S`
            }
            if (iso === 'P') iso = 'PT0S'
            return iso
        },
    },
}
